/* eslint-disable import/prefer-default-export */

export const RATE_TYPES = {
  base: 'base',
  handy: 'handy',
  camera: 'camera',
  cameraHandy: 'camera_handy',
};
